<template>
  <UModal
    :class="ui?.root"
    :ui="{
      content: 'w-full max-w-full h-screen max-h-screen!',
      header: 'hidden',
    }"
  >
    <template #body>
      <SPMobileModalHeader
        class="mb-8"
        :close-btn="true"
        @toggled="closeModal"
      />

      <UContainer>
        <SPHeroSearch settings :class="ui?.searchArea" />
        <UButton
          class="mt-20 w-full"
          :class="ui?.allResultsButton"
          trailing-icon="i-local-chevron-right"
          :ui="{
            base: 'justify-center text-center',
          }"
        >
          Все результаты
        </UButton>
      </UContainer>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'SearchModal',
})

defineProps<{
  ui?: {
    root?: string
    searchArea?: string
    allResultsButton?: string
  }
}>()

const emit = defineEmits<{
  close: []
}>()

const closeModal = () => {
  emit('close')
}
</script>

<style></style>
